import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { OrgProvider } from './context/OrgContext';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import ErrorBoundary from './components/ErrorBoundary';

import Login from './pages/Login';
import Overview from './pages/Overview';
import Invoices from './pages/Invoices';
import Exceptions from './pages/Exceptions';
import Reconciliation from './pages/Reconciliation';
import Suppliers from './pages/Suppliers';
import CreditNotes from './pages/CreditNotes';
import Statements from './pages/Statements';
import ProcessingRuns from './pages/ProcessingRuns';
import Settings from './pages/Settings';
import Profile from './pages/Profile';
import AppAdmin from './pages/AppAdmin';
import AppAdminUsers from './pages/AppAdminUsers';
import AppAdminUsage from './pages/AppAdminUsage';
import AppAdminMaintenance from './pages/AppAdminMaintenance';
import AppAdminLogs from './pages/AppAdminLogs';
import AppAdminApi  from './pages/AppAdminApi';
import AppAdminSecurity from './pages/AppAdminSecurity';
import AppAdminConfig from './pages/AppAdminConfig';
import VersionBanner from './components/VersionBanner';
import Maintenance from './pages/Maintenance';

function RootRedirect() {
  const { user } = useAuth();
  return <Navigate to={user ? '/overview' : '/login'} replace />;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <OrgProvider>
        <VersionBanner />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<RootRedirect />} />

          <Route
            path="/overview"
            element={
              <PrivateRoute>
                <Layout><ErrorBoundary><Overview /></ErrorBoundary></Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/invoices"
            element={
              <PrivateRoute>
                <Layout><ErrorBoundary><Invoices /></ErrorBoundary></Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/credit-notes"
            element={
              <PrivateRoute>
                <Layout><ErrorBoundary><CreditNotes /></ErrorBoundary></Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/exceptions"
            element={
              <PrivateRoute>
                <Layout><ErrorBoundary><Exceptions /></ErrorBoundary></Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/suppliers"
            element={
              <PrivateRoute>
                <Layout><ErrorBoundary><Suppliers /></ErrorBoundary></Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/reconciliation"
            element={
              <PrivateRoute>
                <Layout><ErrorBoundary><Reconciliation /></ErrorBoundary></Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/statements"
            element={
              <PrivateRoute>
                <Layout><ErrorBoundary><Statements /></ErrorBoundary></Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/processing-runs"
            element={
              <PrivateRoute>
                <Layout><ErrorBoundary><ProcessingRuns /></ErrorBoundary></Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <PrivateRoute>
                <Layout><ErrorBoundary><Settings /></ErrorBoundary></Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <Layout><ErrorBoundary><Profile /></ErrorBoundary></Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/app-admin"
            element={
              <PrivateRoute>
                <Layout><ErrorBoundary><AppAdmin /></ErrorBoundary></Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/app-admin/users"
            element={
              <PrivateRoute>
                <Layout><ErrorBoundary><AppAdminUsers /></ErrorBoundary></Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/app-admin/usage"
            element={
              <PrivateRoute>
                <Layout><ErrorBoundary><AppAdminUsage /></ErrorBoundary></Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/app-admin/configuration"
            element={
              <PrivateRoute>
                <Layout><ErrorBoundary><AppAdminConfig /></ErrorBoundary></Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/app-admin/api"
            element={
              <PrivateRoute>
                <Layout><ErrorBoundary><AppAdminApi /></ErrorBoundary></Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/app-admin/security"
            element={
              <PrivateRoute>
                <Layout><ErrorBoundary><AppAdminSecurity /></ErrorBoundary></Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/app-admin/logs"
            element={
              <PrivateRoute>
                <Layout><ErrorBoundary><AppAdminLogs /></ErrorBoundary></Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/app-admin/maintenance"
            element={
              <PrivateRoute>
                <Layout><ErrorBoundary><AppAdminMaintenance /></ErrorBoundary></Layout>
              </PrivateRoute>
            }
          />
          <Route path="/maintenance" element={<Maintenance />} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </OrgProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
